import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import classNames from 'classnames'

import { toRoman } from 'helpers/index'
import { getEndDateMessage } from 'helpers/datetime'
import {
    getPeripheryById,
    isSortiesAvailable,
    isFortBattlesAvailable,
    getClosestMatchmakerTick,
} from 'helpers/peripheries'
import { isUnitDisabled } from '../UnitsList/helpers'

import { Role, Tooltip } from 'react-wot-bootstrap'
import Timer from 'components/Timer/Timer'
import Clan from 'components/Clan/Clan'

import { UNIT_TYPES, USER_ROLES } from 'constants'

import {
    STATUS_MATCHING_LEGIONARIES,
    STATUS_BATTLE_READY_MESSAGE,
    STATUS_IN_BATTLE_MESSAGE,
    STATUS_BATTLE_SCHEDULE_MESSAGE,
    BATTLE_MODE_DISABLED_ON_PERIPHERY,
} from '../../constants'

import {
    BATTLE_ROOMS_UNIT_TOOLTIP_ID,
    UNIT_TOOLTIP_CREATION_TIME,
    UNIT_TOOLTIP_DATA_LABELS,
    UNIT_TOOLTIP_BATTLE_MODE,
    UNIT_TOOLTIP_DISABLED_TEXT,
} from './constants'

import styles from './UnitTooltip.scss'

export class UnitTooltip extends React.Component {
    static propTypes = {
        unitId: PropTypes.number.isRequired,
        clan: PropTypes.object.isRequired,
        inBattle: PropTypes.bool.isRequired,
        inPlayersMatching: PropTypes.bool,
        battleType: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
        battleLevel: PropTypes.number.isRequired,
        createdAt: PropTypes.number.isRequired,
        peripheryId: PropTypes.number.isRequired,
        commanderNickname: PropTypes.string.isRequired,
        commanderRole: PropTypes.oneOf(Object.values(USER_ROLES)).isRequired,
        meta: PropTypes.shape({
            sorties: PropTypes.object.isRequired,
            fort_battles: PropTypes.object.isRequired,
        }),
        isUnitDisabled: PropTypes.bool.isRequired,
    }

    static id = BATTLE_ROOMS_UNIT_TOOLTIP_ID

    getFooterMessage() {
        let periphery
        let isAvailable
        let primetimeStart = null
        if (this.props.battleType === UNIT_TYPES.SORTIE) {
            periphery = getPeripheryById(this.props.meta.sorties.peripheries, this.props.peripheryId)
            isAvailable = isSortiesAvailable(periphery)
            if (periphery) primetimeStart = periphery.primetime_start
        } else {
            periphery = getPeripheryById(this.props.meta.fort_battles.peripheries, this.props.peripheryId)
            isAvailable = isFortBattlesAvailable(periphery)
            if (periphery) primetimeStart = getClosestMatchmakerTick(periphery)
        }

        const positiveStatusClassName = classNames(styles.status, styles.status__positive)
        const negativeStatusClassName = classNames(styles.status, styles.status__negative)
        const highlightStatusClassName = classNames(styles.status, styles.status__highlighted)

        if (this.props.inBattle) {
            return (
                <p className={classNames(styles.status, styles.status__inBattle)}>
                    {STATUS_IN_BATTLE_MESSAGE}
                </p>
            )
        } else if (this.props.inPlayersMatching) {
            return (
                <p className={highlightStatusClassName}>
                    {STATUS_MATCHING_LEGIONARIES}
                </p>
            )
        } else if (isAvailable) {
            return (
                <p className={positiveStatusClassName}>
                    {STATUS_BATTLE_READY_MESSAGE}
                </p>
            )
        } else if (primetimeStart === null) {
            return (
                <p className={negativeStatusClassName}>
                    {BATTLE_MODE_DISABLED_ON_PERIPHERY}
                </p>
            )
        } else {
            const availableTime = getEndDateMessage(moment(primetimeStart))
            return (
                <p className={negativeStatusClassName}>
                    {STATUS_BATTLE_SCHEDULE_MESSAGE(availableTime)}
                </p>
            )
        }
    }

    getCreationTime() {
        const timeNode = (
            <span className={styles.highlight}>
                <Timer startTime={moment(this.props.createdAt)} />
            </span>
        )
        return UNIT_TOOLTIP_CREATION_TIME(timeNode)
    }

    getBattleMode() {
        return UNIT_TOOLTIP_BATTLE_MODE[this.props.battleType](toRoman(this.props.battleLevel))
    }

    render() {
        if (this.props.isUnitDisabled) return (
            <Tooltip id={BATTLE_ROOMS_UNIT_TOOLTIP_ID}>
                <div className={styles.base}>
                    {UNIT_TOOLTIP_DISABLED_TEXT}
                </div>
            </Tooltip>
        )
        return (
            <Tooltip id={BATTLE_ROOMS_UNIT_TOOLTIP_ID}>
                <div className={styles.base}>
                    <Clan {...this.props.clan} battle={this.getBattleMode()} />
                    <div className={styles.ribbon}>
                        {this.getCreationTime()}
                    </div>
                    <p className={styles.message}>
                        <span className={styles.commander}>
                            {UNIT_TOOLTIP_DATA_LABELS.commander}{': '}
                            <Role role={this.props.commanderRole}/>
                            &thinsp;
                            <span className={styles.highlight}>{this.props.commanderNickname}</span>
                        </span>
                    </p>
                    <span className={styles.divider} />
                    {this.getFooterMessage()}
                </div>
            </Tooltip>
        )
    }
}

export const mapStateToProps = ({ availableUnits, clan, clanUnits }, { unitId }) => {
    const { meta } = availableUnits

    let unit = availableUnits.units.find(unit => unit.id === unitId)
    if (!unit) unit = clanUnits.units.find(unit => unit.id === unitId)

    const {
        type,
        in_battle: inBattle,
        players_matching_started_at,
        max_vehicle_level: battleLevel,
        created_at: createdAt,
        commander_role: commanderRole,
        commander_nickname: commanderNickname,
        periphery,
    } = unit

    const peripheryId = periphery.id

    return {
        clan: unit.clan,
        inBattle,
        inPlayersMatching: players_matching_started_at !== null,
        battleType: type,
        battleLevel,
        peripheryId,
        meta,
        createdAt,
        commanderNickname,
        commanderRole,
        isUnitDisabled: isUnitDisabled(unit, clan.id),
    }
}

UnitTooltip.id = BATTLE_ROOMS_UNIT_TOOLTIP_ID

export default connect(mapStateToProps)(UnitTooltip)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitTooltip/UnitTooltip.jsx